import * as z from 'zod';

import { inventoryCategoryQueryLinkerSchema } from '@/_pages/settings/inventory-categories/shared/schemas/inventory-category-query-linker-schema';
import { fileQuerySchema } from '@/_schemas/file';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { inventoryKitQueryLinkerSchema } from './inventory-kits-query-linker-schema';

import { inventoryKitItemQuerySchema } from '../inventory-kit-item/inventory-kit-item-query-schema';

export const inventoryKitQuerySchema = z.object({
  ...inventoryKitQueryLinkerSchema.shape,
  sku: z.string(),
  logo: z.array(fileQuerySchema).nullish(),
  category_id: z.number(),
  category: inventoryCategoryQueryLinkerSchema,
  inventory_kit_items: z.array(inventoryKitItemQuerySchema).nullish(),
});

export type InventoryKitQuerySchema = z.infer<typeof inventoryKitQuerySchema>;

export const inventoryKitQueryAllSchema = paginatedResponseSchema(inventoryKitQuerySchema);

export type InventoryKitQueryAllSchema = z.infer<typeof inventoryKitQueryAllSchema>;
